/*
 * If the PaymentMethod has a code of 'CashOnDelivery', we display the input 'short_description_mpl_type'
 */
export const cashOnDelivery = 'CashOnDelivery';


// WEBPACK FOOTER //
// ./src/modules/PaymentMethod/constants.ts